import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { IoMdEye } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import OnlineBookForm from "./OnlineBookForm";
import useDeleteOnlineBook from "./Hooks/useDeleteOnlineBook";
import DialogDelete from "../../Utils/DialogDelete";

export default function OnlineBookAction({ editData, setRefetch, pageNum }) {
  // Change Language
  let navigate = useNavigate();
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const { handleDelete, loading } = useDeleteOnlineBook({
    handleClose: handleCloseDel,
    editData: editData,
    setRefetch,
  });

  const handleView = () => {
    // console.log("pageNum...", pageNum);
    navigate(`/setting/book-content?bookId=${editData?._id}`);
    // window.localStorage.setItem("pageNum", parseInt(pageNum));
  };

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("view")} placement="top">
          <IconButton onClick={handleView}>
            <Box className="view-container">
              <IoMdEye className="view-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <OnlineBookForm
          dialogTitle={"Update"}
          open={openEdit}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_book")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
